import { render, staticRenderFns } from "./EmailEditorModal.vue?vue&type=template&id=ff210700&scoped=true&"
import script from "./EmailEditorModal.vue?vue&type=script&lang=js&"
export * from "./EmailEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailEditorModal.vue?vue&type=style&index=0&id=ff210700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff210700",
  null
  
)

export default component.exports